var React = require('react');

function AdjustmentOfIndicators (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFD600","d":"M21.957 27.2c4.655 0 8.5-3.845 8.5-8.5 0-4.655-3.845-8.5-8.5-8.5-4.655 0-8.5 3.845-8.5 8.5 0 4.655 3.845 8.5 8.5 8.5Z","key":0}),React.createElement("path",{"fill":"#2D2D2D","fillRule":"evenodd","d":"M1.555 48a.5.5 0 0 1 .5-.5h46a.5.5 0 0 1 0 1h-46a.5.5 0 0 1-.5-.5ZM17.032 7.05a5.94 5.94 0 0 0-5.938 6.116H4.54a.5.5 0 1 0 0 1h6.67a5.942 5.942 0 0 0 11.646 0H46.19a.5.5 0 0 0 0-1H22.97a5.94 5.94 0 0 0-5.937-6.116Zm-4.94 5.94a4.94 4.94 0 1 1 9.88 0 4.94 4.94 0 0 1-9.88 0ZM4.54 32.133h23.163a6.001 6.001 0 0 0 11.976 0h6.51a.5.5 0 1 0 0-1h-6.528a6.002 6.002 0 0 0-11.94 0H4.539a.5.5 0 0 0 0 1Zm29.151-5.39a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z","clipRule":"evenodd","key":1})]);
}

AdjustmentOfIndicators.defaultProps = {"fill":"none","viewBox":"0 0 50 50"};

module.exports = AdjustmentOfIndicators;

AdjustmentOfIndicators.default = AdjustmentOfIndicators;
